// extracted by mini-css-extract-plugin
module.exports = {"footerListTitleItem":"styles_footerListTitleItem__1mWMm"};